import DOC from './DOC.js';
import FileFormat from './FileFormat.js';
import JPG from './JPG.js';
import PDF from './PDF.js';
import PNG from './PNG.js';
import PPT from './PPT.js';
import XLS from './XLS.js';
export const FileTypeIcons = {
    DOC,
    FileFormat,
    JPG,
    PDF,
    PNG,
    PPT,
    XLS,
};
export default FileTypeIcons;
